import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const SuccessPage = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(8);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/portal');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>Pagamento Aprovado - AI7X7</title>
      </Helmet>
      <div
        className="min-h-screen flex items-center justify-center px-4"
        style={{ backgroundColor: '#F7F7F8', fontFamily: "'DM Sans', sans-serif" }}
      >
        <div className="bg-white rounded-2xl shadow-xl p-10 max-w-md w-full text-center">
          {/* Success Icon */}
          <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" style={{ backgroundColor: '#D1FAE5' }}>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="#059669" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>

          <h1 className="text-2xl font-bold text-gray-900 mb-3">
            Pagamento aprovado com sucesso!
          </h1>

          <p className="text-gray-600 leading-relaxed mb-2">
            Parabéns. Seu plano PRO está ativo.
          </p>
          <p className="text-gray-600 leading-relaxed mb-8">
            Agora você pode usar todas as ferramentas sem limites.
          </p>

          {/* PRO Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-8" style={{ backgroundColor: '#FEF3C7', color: '#92400E' }}>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
            <span className="text-sm font-semibold">Plano PRO Ativo</span>
          </div>

          <button
            onClick={() => navigate('/portal')}
            className="w-full py-3 px-6 rounded-xl text-white font-semibold text-sm transition-all duration-200 hover:opacity-90"
            style={{ background: 'linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%)' }}
          >
            Acessar Portal de Ferramentas
          </button>

          <p className="text-xs text-gray-400 mt-4">
            Redirecionando automaticamente em {countdown}s...
          </p>
        </div>
      </div>
    </>
  );
};

export default SuccessPage;
